import type VConsole from 'vconsole';

const INIT_FLAG = '__wl_vconsole_inited__';

type VConsoleHost = Window & {
  [INIT_FLAG]?: boolean;
  __wlVConsole?: VConsole;
};

function getHost(): VConsoleHost | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return window as unknown as VConsoleHost;
}

function hideDefaultSwitch(): void {
  const switchEl = document.querySelector<HTMLElement>('#__vconsole .vc-switch');
  if (switchEl) {
    switchEl.style.display = 'none';
  }
}

async function ensureVConsole(): Promise<VConsole | null> {
  const host = getHost();
  if (!host) {
    return null;
  }
  if (host.__wlVConsole) {
    hideDefaultSwitch();
    return host.__wlVConsole;
  }

  const { default: VConsoleCtor } = await import('vconsole');
  if (host.__wlVConsole) {
    hideDefaultSwitch();
    return host.__wlVConsole;
  }

  const instance = new VConsoleCtor({ theme: 'dark' });
  instance.hideSwitch();
  hideDefaultSwitch();
  host.__wlVConsole = instance;
  host[INIT_FLAG] = true;
  return instance;
}

function isVConsolePanelOpen(): boolean {
  const panel = document.querySelector<HTMLElement>('#__vconsole .vc-panel');
  if (!panel) {
    return false;
  }
  const style = window.getComputedStyle(panel);
  return style.display !== 'none' && style.visibility !== 'hidden';
}

/** 入口已改为控制面板按钮，启动时不再自动弹出绿色悬浮球。 */
export function initVConsoleIfNeeded(): void {
  return;
}

export async function toggleVConsole(): Promise<void> {
  const instance = await ensureVConsole();
  if (!instance) {
    return;
  }
  hideDefaultSwitch();
  if (isVConsolePanelOpen()) {
    instance.hide();
    return;
  }
  instance.show();
}
